import { useState, useEffect } from "react";
import { __ } from "@wordpress/i18n";
import apiFetch from "@wordpress/api-fetch";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import ContentHeader from "../../components/ContentHeader";

const Extra = () => {

	const [isSaving, setIsSaving] = useState(false);
	const [isUninstallEnabled, setIsUninstallEnabled] = useState(null);
	const [originalValue, setOriginalValue] = useState(null);
	const [hasChanges, setHasChanges] = useState(false);
	const [isSaved, setIsSaved] = useState(false);

	useEffect(() => {
		loadSettings();
	}, []);

	// Check for changes whenever isUninstallEnabled changes
	useEffect(() => {
		// Only check for changes if we have loaded the original value
		if (originalValue !== null && isUninstallEnabled !== null) {
			setHasChanges(originalValue !== isUninstallEnabled);
		}
	}, [isUninstallEnabled, originalValue]);

	const handleIsShopManagerEnabled = () => {
		setIsUninstallEnabled((prev) => !prev);
	};

	const loadSettings = async () => {
		try {
			const response = await apiFetch({
				path: "/plac/v1/extra",
				method: "GET",
			});
            console.log(response);
			setIsUninstallEnabled(response.settings.enable_clean_data_on_uninstall);
			setOriginalValue(response.settings.enable_clean_data_on_uninstall);
			setHasChanges(false);
		} catch (error) {
			console.error("Error loading settings:", error);
			// Set a default value in case of error
			setIsUninstallEnabled(false);
			setOriginalValue(false);
		}
	};
	const saveSettings = async () => {
		setIsSaving(true);
		setIsSaved(false); // Reset saved state

		try {
			await apiFetch({
				path: "/plac/v1/extra",
				method: "POST",
				data: {
					_wpnonce: window.placAdminData.nonce,
					enable_clean_data_on_uninstall: isUninstallEnabled,
				},
			});
			// Update the original value to match the current value
			setOriginalValue(isUninstallEnabled);
			setHasChanges(false);

			// Show success checkmark after saving
			setTimeout(() => {
				setIsSaving(false);
				setIsSaved(true);

				// Reset to default state after 2s
				setTimeout(() => {
					setIsSaved(false);
				}, 1000);
			}, 500);
		} catch (error) {
			console.error("Error saving settings:", error);
			setIsSaving(false);
		}
	};
	

	const discardChanges = () => {
		setIsUninstallEnabled(originalValue);
		setHasChanges(false);
	};

	// Only render the actual toggle once we have the data
	const isLoading = isUninstallEnabled === null;

	return (
		<>
			
			<div className="settings-container">
				<ContentHeader
					title={
						"Settings"
					}
					description={
						"Lorem ipsum dolor sit amet consectetur. Massa a eu elit gravida diam purus. Odio sodales fermentum pellentesque tincidunt proin. "
					}
				/>

				<div className="content-section">
					<div className="leftSection">
						<h2 className="title header-1 primary-text-color semi-bold">
							{__("Uninstall option", "access-control")}
						</h2>
						
					</div>

					<div className="rightSection">
						<div className="setting-item">
							<div className="input-container">
								<OverlayTrigger
									placement="top"
									overlay={
										<Tooltip id="uninstall-plugin-tooltip">
											{__(
												"Delete all the plugin data",
												"access-control",
											)}
										</Tooltip>
									}
								>
									<img
										src={`${window.placAdminData.pluginUrl}/assets/images/question.svg`}
										alt="icon"
										className="icon"
										style={{ cursor: "pointer" }}
									/>
								</OverlayTrigger>

								<div className="input-field">
									<span className="setting-label header-1 primary-text-color semi-bold">
										{__("Delete all the plugin data upon uninstalling.", "access-control")}
									</span>
									{isLoading ? (
										<div
											className="pl-access-control-switch-placeholder"
											style={{
												width: "40px",
												height: "20px",
											}}
										></div>
									) : (
										<label className="pl-access-control-switch">
											<input
												type="checkbox"
												checked={isUninstallEnabled}
												onChange={
													handleIsShopManagerEnabled
												}
											/>
											<span
												className={`pl-access-control-slider round ${
													isUninstallEnabled
														? "checked"
														: ""
												}`}
											></span>
										</label>
									)}
								</div>
							</div>
                                <div style={{marginLeft: "30px"}}>
                                    {__("All role modifications and custom roles created using this plugin are stored in the database. If you wish to remove this data when uninstalling the plugin, please check the checkbox below. Before proceeding with the uninstallation, ensure that no users are assigned to these custom roles, as deleting this data while roles are still in use may result in technical issues.","access-control")}
                                </div>
							
						</div>
					</div>
				</div>

				<div className="footer-section">
					<button
					className={`save-button purple-bg-40 secondary-text-color ${!hasChanges ? "disabled" : ""}`}
					disabled={isLoading || isSaving || !hasChanges}
					onClick={saveSettings}
				>
					{isSaving ? (
						<div className="saving-changes secondary-text-color">
							<div className="pl-access-control-loading-spinner"></div>
							{__("Changes Saving...", "access-control")}
						</div>
					) : isSaved ? (
						<div className="success-checkmark secondary-text-color">
							<img
								src={`${window.placAdminData.pluginUrl}/assets/images/success-tick.svg`}
								alt="quotation-icon"
							/>
							{__("Changes Saved", "access-control")}
						</div>
					) : (
						__("Save Change", "access-control")
					)}
				</button>

					<button
						className={`discard-button purple-text-color btn-border ${!hasChanges ? "disabled" : ""}`}
						disabled={isLoading || !hasChanges}
						onClick={discardChanges}
					>
						{__("Discard Changes", "access-control")}
					</button>
					{hasChanges && (
						<div className="unsaved-changes">
							<img
								src={`${window.placAdminData.pluginUrl}/assets/images/quotation.svg`}
								alt="quotation-icon"
							/>
							{__("Unsaved Changes", "access-control")}
						</div>
					)}
					
				</div>
			</div>
		</>
	);
};

export default Extra;